import React from 'react';
import bn from "../../../utils/bemnames";
import {ICompetitorOdds, IOutrightOddsWidgetResponse} from '../../../api/outright-odds';
import {_t} from '../../../utils/translations';
import Dropdown from '../../Dropdown';
import ImgWithDefault from '../../ImgWithDefault';
import {IProvider, IWidgetAvailableMarket, IWidgetProvider} from '../../../utils/types';
import {getLoadingBlockHeight, getUniqueProviders, sortProvidersByIds} from '../../../utils/outright-odds';
import LoadingBlock from '../../LoadingBlock';
import {getProviderImageUrl} from '../../../utils/providers';
import CompetitorRowDesktop from './CompetitorRowDesktop';
import {
  Accordion,
  AccordionItem
} from "react-accessible-accordion";

interface IProps {
  competitorOdds: ICompetitorOdds[],
  widget: IOutrightOddsWidgetResponse,
  changedMarketType: (newSelectedMarketType: string | number) => void;
  loading: boolean;
  availableMarkets: IWidgetAvailableMarket[];
  listRangeFrom?: number | null;
  listRangeTo?: number | null;
}

const bem = bn.create('outright-odds-desktop');

const OutrightOddsTableDesktop: React.FC<IProps> = (
  {
    competitorOdds,
    widget,
    loading,
    changedMarketType,
    availableMarkets = [],
    listRangeFrom = null,
    listRangeTo = null,
  }
) => {
  const providers = sortProvidersByIds(
    getUniqueProviders(competitorOdds.map(competitorOdd => competitorOdd.outRightOddsData.odds)),
    widget.widgetProviders.map((widgetProvider: IWidgetProvider) => widgetProvider.providerId)
  )

  return (
    <div className={bem.b()}>
      <div className={bem.e('legend')}>
        <div className={bem.e('odds-description')}>
          <div className={bem.e('odds-description-item')}>
            <div
              className={`${bem.e('odds-description-item__icon')} ${bem.e('odds-description-item__icon--shortening')}`}/>
            <div className={bem.e('odds-description-item__title')}>{_t('Odds shortening')}</div>
          </div>
          <div className={bem.e('odds-description-item')}>
            <div
              className={`${bem.e('odds-description-item__icon')} ${bem.e('odds-description-item__icon--drifting')}`}/>
            <div className={bem.e('odds-description-item__title')}>{_t('Odds drifting')}</div>
          </div>
          <div className={bem.e('odds-description-item')}>
            <div className={`${bem.e('odds-description-item__icon')} ${bem.e('odds-description-item__icon--best')}`}/>
            <div className={bem.e('odds-description-item__title')}>{_t('Best Odds')}</div>
          </div>
        </div>
        <div className={bem.e('markets')}>
          {(availableMarkets.length > 1) ? (
            <Dropdown
              loading={loading}
              options={availableMarkets}
              valueDefault={0}
              onChange={(value: string | number): void => {
                changedMarketType(value)
              }}
              placeholder={_t('Markets')}
            />
          ) : (
            <>
              {availableMarkets.map((am, index) => (<div className={bem.e('one-item')} key={'market_type_'+index}>{_t(am.title)}</div>))}
            </>
          )}

        </div>
      </div>
      {loading ? (
        <LoadingBlock
          isMobile={false}
          height={getLoadingBlockHeight(listRangeFrom, listRangeTo, false)}
          heightMobile={getLoadingBlockHeight(listRangeFrom, listRangeTo, true)}
        />
      ) : <div className={bem.e('content')}>
        <div className={bem.e('table')}>
          <div className={bem.e('header')}>
            <div className={bem.e('competitor')}>
              <div className={`${bem.e('column')} ${bem.e('column__button')}`}></div>
              <div className={`${bem.e('column')} ${bem.e('column__logo')}`}></div>
              <div className={`${bem.e('column')} ${bem.e('column__title')}`}></div>
            </div>
            <div className={bem.e('odds')}>
              {providers.map((provider: IProvider, index) => (
                <div className={`${bem.e('column')} ${bem.e('column__provider')}`} key={index}>
                  <ImgWithDefault
                    className={bem.e('provider-logo')}
                    src={getProviderImageUrl(provider)}
                    alt={provider.name}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className={bem.e('body')}>
            <Accordion
              allowZeroExpanded={true}
            >
              {competitorOdds.map((competitorOdd: ICompetitorOdds, index) => (
                <AccordionItem
                  key={index}
                  className={bem.e('row')}
                >
                  <CompetitorRowDesktop
                    competitorOdd={competitorOdd}
                    languageId={widget.languageId}
                    allowedProvidersIds={widget.widgetProviders.map(widgetProvider => widgetProvider.providerId)}
                    outRightOddsProviders={providers}
                    oddsFormat={widget.oddsFormat}
                    outLinkFolder={widget.outLinkFolder}
                    widgetId={widget.id}
                  />
                </AccordionItem>
              ))}
            </Accordion>

          </div>
        </div>
      </div>}
    </div>
  )
}


export default OutrightOddsTableDesktop;
